// DPIA acțiunea A4 — avertismentul afișat la activarea unei integrări (riscul R9).
//
// Când clientul conectează un furnizor extern cu propriul cont, datele din CRM
// încep să circule către el. Contractul spune deja cine răspunde (Anexa 4 din
// DPA: furnizorii de mai jos NU sunt subîmputerniciți ai MiriDar), dar un
// contract semnat o dată nu este vizibil în momentul în care cineva lipește o
// cheie API. Catalogul de aici face consecința vizibilă exact atunci.
//
// Conținutul oglindește Anexa 4. Nu adăugăm afirmații juridice noi și nu
// promitem conformitate în numele clientului.

export const INTEGRATION_PRIVACY_CATALOG = Object.freeze({
  external_api: {
    providerKey: "externalApi",
    // Endpoint intern: datele nu părăsesc infrastructura MiriDar, dar sistemul
    // care trimite este al clientului.
    locationKey: "miridar",
    transfersOutside: false,
  },
  mailjet: {
    providerKey: "mailjet",
    locationKey: "eu",
    transfersOutside: false,
  },
  smtp: {
    providerKey: "smtp",
    // Serverul este ales de client; nu putem ști unde se află.
    locationKey: "clientChosen",
    transfersOutside: true,
  },
  pbx: {
    providerKey: "pbx",
    locationKey: "clientChosen",
    transfersOutside: true,
  },
  telegram: {
    providerKey: "telegram",
    locationKey: "outside",
    transfersOutside: true,
  },
  ai: {
    providerKey: "ai",
    // Furnizorii AI ridică suplimentar întrebarea antrenării pe datele trimise.
    locationKey: "outside",
    transfersOutside: true,
    modelTrainingWarning: true,
  },
});

export const resolveIntegrationPrivacy = (key) =>
  INTEGRATION_PRIVACY_CATALOG[String(key || "").trim()] || null;

export const INTEGRATION_KEYS = Object.freeze(Object.keys(INTEGRATION_PRIVACY_CATALOG));
